import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const TextComponent = props => {
  const { alignment, title, subtitle, link } = props.config;
  // default values
  const Header1 = title && !!title.tag ? `${title.tag}` : 'h3';
  const Header2 = subtitle && !!subtitle.tag ? `${subtitle.tag}` : 'p';
  const tclass1 = title && !!title.class1 ? title.class1 : 'text-2xl';
  const tclass2 = title && !!title.class2 ? title.class2 : 'text-default';
  const stclass1 =
    subtitle && !!subtitle.class1 ? subtitle.class1 : 'text-base';
  const stclass2 =
    subtitle && !!subtitle.class2 ? subtitle.class2 : 'text-default';
  const linkClass1 = link && !!link.class1 ? link.class1 : 'text-lg';
  const linkClass2 = link && !!link.class2 ? link.class2 : 'text-default';

  const textAlignment = {
    center: ['center', 'center'],
    top: ['flex-start', 'center'],
    bottom: ['flex-end', 'center'],
    left: ['center', 'flex-start'],
    right: ['center', 'flex-end'],
    topleft: ['flex-start', 'flex-start'],
    topright: ['flex-start', 'flex-end'],
    bottomleft: ['flex-end', 'flex-start'],
    bottomright: ['flex-end', 'flex-end'],
  };

  return (
    <div className="w-full relative flex justify-center items-center">
      <div
        className="p-8 h-full w-full flex z-[1] flex-col text-center"
        style={{
          justifyContent:
            (alignment &&
              textAlignment[alignment] &&
              textAlignment[alignment][0]) ||
            'center',
          alignItems:
            (alignment &&
              textAlignment[alignment] &&
              textAlignment[alignment][1]) ||
            'center',
        }}
      >
        {!!title && title.content && (
          <Header1 className={`${tclass1} ${tclass2} max-w-[30em] font-bold`}>
            {' '}
            {title && title.content}{' '}
          </Header1>
        )}
        {!!subtitle && subtitle.content && (
          <Header2 className={`${stclass1} ${stclass2} max-w-[30em] font-bold`}>
            {' '}
            {subtitle && subtitle.content}{' '}
          </Header2>
        )}
        {!!link && link.content && (
          <Link
            to={link.linkTo}
            className={`${linkClass1} ${linkClass2} border-2 border-solid border-white px-4 py-2.5 mt-3 font-bold`}
          >
            {' '}
            {link && link.content}{' '}
          </Link>
        )}
      </div>
    </div>
  );
};

TextComponent.propTypes = {
  config: PropTypes.shape({
    alignment: PropTypes.string,
    link: PropTypes.shape({
      class1: PropTypes.string,
      class2: PropTypes.string,
      content: PropTypes.string,
      linkTo: PropTypes.string,
      tag: PropTypes.string,
    }),
    subtitle: PropTypes.shape({
      class1: PropTypes.string,
      class2: PropTypes.string,
      content: PropTypes.string,
      tag: PropTypes.string,
    }),
    title: PropTypes.shape({
      class1: PropTypes.string,
      class2: PropTypes.string,
      content: PropTypes.string,
      tag: PropTypes.string,
    }),
  }),
};

const TextComponentUI = props => {
  if (props?.config?.elementAttribute?.id) {
    return (
      <div id={props?.config?.elementAttribute?.id}>
        <TextComponent {...props} />
      </div>
    );
  }
  return <TextComponent {...props} />;
};

TextComponentUI.propTypes = {
  config: PropTypes.shape({
    elementAttribute: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default TextComponentUI;
